import PenaltyStatusConfig from './penalty-status';
import ProductionAndPayoutConfig from './production-and-payout';
import QualityStatusConfig from './quality-status';
import PickupsAndLabsConfig from './pickups-and-labs';

export default [...PenaltyStatusConfig, ...ProductionAndPayoutConfig, ...QualityStatusConfig, ...PickupsAndLabsConfig];
